import {Component} from '@angular/core';
import {CoreProductsBase} from 'src/app/col/utils/core-products-base';
import {LangProductMapper} from 'src/app/col/utils/lang-mappers';
import {SpinnerService} from 'src/app/utils/services/spinner.service';
import {StudentShoppingCartService} from "../../../../services/student-shopping-cart.service";
import { NativeServiceApiProvider } from '../../../../../services/native-api-provider.service';
import { ProductsUtilsV3 } from 'src/app/col/utils/v3/products-utils';

@Component({
    selector: 'app-kids-products',
    templateUrl: './kids-products.component.html',
    styleUrls: ['./kids-products.component.scss'],
    standalone: false
})
export class KidsProductsComponent extends CoreProductsBase {
  constructor(apiProvider: NativeServiceApiProvider,
              spinner: SpinnerService,
              shoppingCart: StudentShoppingCartService) {
    super(apiProvider, spinner, shoppingCart);
  }

  getLangName() {
    return LangProductMapper.mapLangCodeToLangName('en.ch');
  }

  getEbookCategoryLabel(): string {
    return 'category:ebook.kids';
  }
  getPaygCategoryLabel(): string {
    return 'category:lessons.en.ch.pag';
  }
  getIntensiveCategoryLabel(): string {
    return 'category:lessons.en.ch.int';
  }
  getStdCategoryLabel(): string {
    return 'category:lessons.en.ch.std';
  }
  getLightCategoryLabel(): string {
    return 'category:lessons.en.ch.light';
  }
  getProductsLabel(): string {
    return ProductsUtilsV3.EN_CH_PRODUCT_LABEL;
  }
}
